<template>
  <Layout
    @componentKey="gotRefresh"
    @currentPage="currentPage"
    :amount="this.disallowedIPC.state === 'false' ? 5 : 4"
    :amountToShow="1"
    :hasPagination="true"
    :hasBackButton="true"
    :hasBreadcrumbs="false"
  >
    <div class="content-dhr">
      <MainTitle :title="pageTitle" />
      <GeneralDHRInfo
        :data="DHRGenalInfo"
        :isApproved="DHRGenalInfo.dateCreated != DHRGenalInfo.dateApproved"
      />

      <div v-if="this.pagina == 1" class="page">
        <div class="page-content">
          <ListDHRDetailProduction
            :data="DHRFlowSteps"
            :doneData="DHRDoneSteps"
          />
        </div>
        <div class="sidebar">
          <DHRApprovalView
            :isApproved="
              DHRGenalInfo.created == 1 && DHRGenalInfo.finished == 1
            "
            :data="DHRGenalInfo"
            :approvalData="DHRApproval"
            :approver="approver"
          />
          <DHRQRView :data="DHRGenalInfo" />
        </div>
      </div>

      <div v-if="this.pagina == 2" class="page">
        <div class="sidebar sidebar-left">
          <DHRImageView :data="DHRAssembly" />
        </div>
        <div class="page-content">
          <ListDHRDetailSubparts :data="DHRAssemblySubparts" />
        </div>
      </div>
      <div v-if="this.pagina == 3" class="page">
        <div class="sidebar-sm">
          <DHRProductionStepMenu
            :data="DHRFlowSteps"
            @selectedStep="showStepDetails"
            :doneData="DHRDoneSteps"
          />
        </div>
        <div class="page-content">
          <ListDHRCustomValues
            :data="selectedStepData"
            :inspection="DHRInspection"
          />
        </div>
      </div>

      <div v-if="this.pagina == 4" class="page">
        <div class="page-content content-inspect">
          <ListDHRInspectionValues
            :DHRID="DHRGenalInfo.DHRID"
            :totalSamples="totalInspectionSamples"
            :data="DHRInspection"
            :flowID="this.DHRFlowSteps[0].flowID"
            :completed="DHRGenalInfo.finished"
            :measurment="measurement"
            :checkValues="checkValues"
            :checkDevice="checkDevice"
          />
        </div>
        <div class="sidebar sidebar-inspect">
          <DHRImageView :data="DHRAssembly" />
        </div>
      </div>

      <div v-if="this.pagina == 5" class="page">
        <div class="page-content content-inspect">
          <ListDHRIpcValues
            :DHRID="DHRGenalInfo.DHRID"
            :totalSamples="totalInspectionSamples"
            :data="DHRIpc"
            :flowID="this.DHRFlowSteps[0].flowID"
            :completed="DHRGenalInfo.finished"
            :measurment="measurementIPC"
            :checkValues="checkValuesIPC"
            :checkDevice="checkDeviceIPC"
          />
        </div>
        <div class="sidebar sidebar-inspect">
          <DHRImageView :data="DHRAssembly" />
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
// @ is an alias to /src
import Layout from "@/layouts/Dashboard";
import MainTitle from "@/components/base/MainTitle";
import GeneralDHRInfo from "@/components/GeneralDHRInfo";
import ListDHRDetailProduction from "@/components/ListDHRDetailProduction";
import ListDHRDetailSubparts from "@/components/ListDHRDetailSubparts";
import DHRApprovalView from "@/components/DHRApprovalView";
import DHRQRView from "@/components/DHRQRView";
import DHRImageView from "@/components/DHRImageView";
import DHRProductionStepMenu from "@/components/DHRProductionStepMenu";
import ListDHRCustomValues from "@/components/ListDHRCustomValues";
import DHRSampleMenu from "@/components/DHRSampleMenu";
import ListDHRInspectionValues from "@/components/ListDHRInspectionValues";
import ListDHRIpcValues from "@/components/ListDHRIpcValues";

export default {
  name: "production-inProgress",
  components: {
    Layout,
    MainTitle,
    GeneralDHRInfo,
    ListDHRDetailProduction,
    ListDHRDetailSubparts,
    DHRApprovalView,
    DHRQRView,
    DHRImageView,
    DHRProductionStepMenu,
    ListDHRCustomValues,
    DHRSampleMenu,
    ListDHRInspectionValues,
    ListDHRIpcValues,
  },
  props: {
    compKey: Number,
  },
  data() {
    return {
      DHRGenalInfo: {},
      DHRFlowSteps: [],
      DHRDoneSteps: [],
      DHRAssembly: {},
      DHRAssemblySubparts: [],
      DHRSteps: [],
      DHRStepCompletion: [],
      DHRStepDeviation: [],
      DHRInspection: [],
      DHRIpc: [],
      DHRIpcValues: [],
      measurement: [],
      measurementIPC: [],
      approver: {},
      DHRApproval: {},
      disallowedIPC: {},

      DHRqr: String,
      DHR: String,
      pagina: 1,
      pageTitle: "General info",
      DHRid: String,
      DHRLot: String,
      totalInspectionSamples: 1,
      totalIpcSamples: 2,
      selectedStepData: {},
      selectedInspectionData: {},
      selectedIPCData: {},

      checkDevice: [],
      checkDeviceIPC: [],

      checkValues: [],
      checkValuesIPC: [],
    };
  },
  beforeMount() {
    this.getData();
    // this.setLists();
  },
  methods: {
    getData() {
      var that = this;
      this.DHRid = that.$router.currentRoute.params.dhrid;
      this.DHRLot = that.$router.currentRoute.params.dhrlot;

      this.pageTitle = "General info (DHR: " + this.DHRLot + ")";

      this.$http
        .get(this.$endpoint + "production/dhr/detail/" + this.DHRid)
        .then((response) => {
          this.DHRGenalInfo = response.data.detail[0];
          this.DHRAssembly = response.data.parts[0];
          this.DHRDoneSteps = response.data.stepsDone;
          let steps = response.data.steps.sort((a, b) =>
            a.order > b.order ? 1 : -1
          );
          // console.log(steps, "steps");
          this.DHRFlowSteps = steps;
          this.DHRSteps = response.data.customStep;
          this.DHRStepValues = response.data.customStepValues;
          this.DHRStepDeviation = response.data.deviations;
          this.DHRAssemblySubparts = response.data.subparts;
          this.DHRStepCompletion = response.data.stepValues;
          this.DHRInspection = response.data.inspection;
          this.DHRIpc = response.data.IPC;
          this.approver = response.data.approver;
          (this.DHRApproval = response.data.DHRInspection[0]),
            (this.disallowedIPC = response.data.disallowedIPC);
          this.DHRApproval.date = response.data.detail[0].dateApproved;
          this.measurement = response.data.measurements;
          this.measurementIPC = response.data.measurementsIPC;

          this.DHRFlowSteps = this.DHRFlowSteps.map((step) => ({
            ...step,
            isCompleted: this.filterDoneStep(step.stepID),
          }));

          if (response.data.detail[0].lotID == "") {
            this.totalInspectionSamples = Math.floor(
              Math.sqrt(response.data.detail[0].amount)
            );
            this.totalIpcSamples = Math.floor(
              response.data.detail[0].amount / 50
            );
            if (this.totalIpcSamples < 2) {
              this.totalIpcSamples = 2;
            }
          } else {
            if (response.data.parts[0].deviceRef.substring(0, 2) == "90") {
              this.totalInspectionSamples = Math.floor(
                Math.sqrt(response.data.detail[0].amount)
              );
            } else {
              this.totalInspectionSamples = response.data.detail[0].amount;
            }
            this.totalIpcSamples = 0;
          }

          this.checkValues = [];
          this.checkDevice = [];

          let counter = 0;

          for (const v in this.DHRInspection[0].values) {
            // console.log(this.DHRInspection[0].values[v]);
            if (this.DHRInspection[0].values[v].letter !== "bool") {
              if (this.measurement[0]) {
                this.checkDevice[counter] = {
                  value: response.data.measurements[counter].device
                    ? response.data.measurements[counter].device
                    : "-",
                  letter: response.data.measurements[counter].letter
                    ? response.data.measurements[counter].letter
                    : this.DHRInspection[0].values[v].letter,
                  dhrID: this.DHRInspection[0].values[0].DHRID,
                };
                counter++;
              } else {
                this.checkDevice[counter] = {
                  value: "-",
                  letter: this.DHRInspection[0].values[v].letter,
                  dhrID: this.DHRInspection[0].values[0].DHRID,
                };
                counter++;
              }
            }
          }

          this.checkDevice.sort((a, b) => (a.letter > b.letter ? 1 : -1));

          for (let s = 0; s < this.totalInspectionSamples; s++) {
            let sample = this.DHRInspection[s];

            let defChecks = [];
            let custChecks = [];

            for (let v = 0; v < sample.values.length; v++) {
              if (sample.values[v].letter == "bool") {
                defChecks.push(sample.values[v]);
              } else {
                custChecks.push(sample.values[v]);
              }
            }

            defChecks.sort((a, b) =>
              a.inspectionName > b.inspectionName ? 1 : -1
            );
            custChecks.sort((a, b) => (a.letter > b.letter ? 1 : -1));

            sample.values = custChecks.concat(defChecks);

            this.checkValues.push(sample);
          }

          this.checkDeviceIPC = [];

          if (this.DHRIpc[0]) {
            counter = 0;
            try {
              for (const v in this.DHRIpc[0].values) {
                if (this.DHRIpc[0].values[v].letter !== "bool") {
                  if (response.data.measurementsIPC[0]) {
                    this.checkDeviceIPC[counter] = {
                      value: response.data.measurementsIPC[counter].device
                        ? response.data.measurementsIPC[counter].device
                        : "-",
                      letter: response.data.measurementsIPC[counter].letter
                        ? response.data.measurementsIPC[counter].letter
                        : this.DHRIpc[0].values[v].letter,
                      dhrID: this.DHRIpc[0].values[0].DHRID,
                    };
                    counter++;
                  } else {
                    this.checkDeviceIPC[counter] = {
                      value: "-",
                      letter: this.DHRIpc[0].values[v].letter,
                      dhrID: this.DHRIpc[0].values[0].DHRID,
                    };
                    counter++;
                  }
                }
              }
            } catch (err) {
              console.log(err);
            }

            // console.log(this.checkDeviceIPC);
            this.checkDeviceIPC.sort((a, b) => (a.letter > b.letter ? 1 : -1));
            // console.log(this.checkDeviceIPC);

            for (let s = 0; s < this.DHRIpc.length; s++) {
              let sample = this.DHRIpc[s];
              let defChecks = [];
              let custChecks = [];

              for (let v = 0; v < sample.values.length; v++) {
                if (sample.values[v].letter == "bool") {
                  defChecks.push(sample.values[v]);
                } else {
                  custChecks.push(sample.values[v]);
                }
              }

              defChecks.sort((a, b) => (a.IPCName > b.IPCName ? 1 : -1));
              custChecks.sort((a, b) => (a.letter > b.letter ? 1 : -1));

              sample.values = custChecks.concat(defChecks);
              // console.log(JSON.stringify(sample.values))

              const ids = sample.values.map((o) => o.IPCID);
              const filtered = sample.values.filter(
                ({ IPCID }, index) => !ids.includes(IPCID, index + 1)
              );

              // console.log(filtered);
              // console.log(filtered.length);

              sample.values = filtered;

              this.checkValuesIPC.push(sample);
            }
          }
        })
        .catch((error) => {
          console.log(error);
          if (error.response.status === 401) {
            this.$store
              .dispatch("logout")
              .then(() => this.$router.push("/login"))
              .catch((err) => console.log(err));
          } else {
            that.$swal(
              "Oops that went wrong?",
              `Please contact the admin with the following info: ${error}`,
              "error"
            );
          }
        });

      // console.log("this.DHRInspection", this.DHRInspection);
    },
    filterDoneStep(stepid) {
      let stepIndex = this.DHRDoneSteps.findIndex((x) => x.stepID == stepid);
      if (stepIndex >= 0) {
        // this.DHRDoneSteps.splice(stepIndex, 1);
        return true;
      } else {
        return false;
      }
    },
    currentPage(page) {
      this.pagina = page;
    },
    gotRefresh(val) {
      this.pagina = 1;
      this.amount = 0;
      this.getData();
    },
    gotRefreshPageData(val) {
      this.getData();
    },
    setLists() {
      this.checkValues = [];
      const measuredevice = this.measurment;
      let counter = 0;
      if (this.receivedInspection[0]) {
        for (const v in this.receivedInspection[0].values) {
          if (this.receivedInspection[0].values[v].letter !== "bool") {
            if (measuredevice[0]) {
              this.checkDevice[v] = {
                value: measuredevice[counter].device,
                letter: this.receivedInspection[0].values[v].letter,
                dhrID: this.receivedInspection[0].values[0].DHRID,
              };
              counter++;
            } else {
              this.checkDevice[v] = {
                value: "-",
                letter: this.receivedInspection[0].values[v].letter,
                dhrID: this.receivedInspection[0].values[0].DHRID,
              };
              counter++;
            }
          }
        }
        for (let s = 0; s < this.totalSamples; s++) {
          let sample = this.receivedInspection[s];

          let defChecks = [];
          let custChecks = [];

          for (let v = 0; v < sample.values.length; v++) {
            if (sample.values[v].letter == "bool") {
              defChecks.push(sample.values[v]);
            } else {
              custChecks.push(sample.values[v]);
            }
          }

          defChecks.sort((a, b) =>
            a.inspectionName > b.inspectionName ? 1 : -1
          );
          custChecks.sort((a, b) => (a.letter > b.letter ? 1 : -1));

          sample.values = custChecks.concat(defChecks);

          this.checkValues.push(sample);
        }
      }
    },
    showStepDetails(step) {
      let detailIndex = this.DHRFlowSteps.findIndex(
        (x) => x.stepID == step.id && x.order == step.order
      );
      let completionIndex = this.DHRStepCompletion.findIndex(
        (x) => x.stepID == step.id
      );
      let deviationIndex = this.DHRStepDeviation.findIndex(
        (x) => x.stepID == step.id
      );

      if (this.DHRStepDeviation[deviationIndex]) {
        if (
          Number(this.DHRStepDeviation[deviationIndex].stepOrder) != step.order
        ) {
          deviationIndex = -1;
        }
      }


     let steptime = this.DHRStepCompletion[detailIndex]
        ? this.DHRStepCompletion[detailIndex].date
        : "";

     let filteredSteps = this.DHRSteps.filter((x) => x.stepID == step.id).map(
        (x) => x
      );

      let filteredValues = filteredSteps.map((step) => {
        let matchingValue;
        matchingValue = this.DHRStepValues.find(
          (x) =>
            x.stepValueID == step.id &&
            x.stepID == step.stepID &&
            x.date == steptime
        );

        if(!matchingValue) {
              matchingValue = this.DHRStepValues.find(
          (x) =>
            x.stepValueID == step.id &&
            x.stepID == step.stepID
        );
        }


        return {
          ...step,
          value: matchingValue ? matchingValue.value : "",
        };
      });


      this.selectedStepData = {
        stepDetails: this.DHRFlowSteps[detailIndex],
        stepDeviations: this.DHRStepDeviation[deviationIndex],
        stepCompletion: this.DHRStepCompletion[detailIndex],
        stepValues: filteredValues,
      };
    },
    // showInspectionDetails(inspection){
    //   console.log(inspection)
    //   let filteredValues = this.DHRInspectionValues.filter(x => x.number == inspection).map(x => x);

    //   this.selectedInspectionData = {
    //     "inspectionDetails": this.DHRInspection,
    //     "inspectionValues": filteredValues
    //   }
    // },
    // showIpcDetails(ipc) {
    //   console.log(ipc)
    //   let filteredValues = this.DHRIpcValues.filter(x => x.number == ipc).map(x => x);

    //   this.selectedIPCData = {
    //     "ipcDetails": this.DHRIpc,
    //     "ipcValues": filteredValues
    //   }
    // }
  },
  watch: {
    pagina: function (val) {
      switch (val) {
        case 1:
          this.pageTitle = "General info (DHR: " + this.DHRLot + ")";
          break;
        case 2:
          this.pageTitle = "Technical drawing (DHR: " + this.DHRLot + ")";
          break;
        case 3:
          this.pageTitle = "Production details (DHR: " + this.DHRLot + ")";
          break;
        case 4:
          this.pageTitle = "Final inspection (DHR: " + this.DHRLot + ")";
          break;
        case 5:
          this.pageTitle = "In Process Control (DHR: " + this.DHRLot + ")";
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/content.scss";
@import "@/style/components/sidebar.scss";

.sidebar-inspect {
  width: 30% !important;
  min-width: 30% !important;
  max-width: 30% !important;
}

.content-inspect {
  width: 68% !important;
  min-width: 68% !important;
  max-width: 68% !important;
}
</style>;
